import { IMinerProfileEditorStore } from "@mobx/store/minerProfiles/editor";
import useApiRequests from "@services/http/useApiRequest";
import {
  AddMinerProfile,
  AddMinerProfileResponse,
  IAddMinerProfileParams,
} from "@services/minerProfiles";
import { addMinerProfile } from "@store/minerProfiles/actions";
import { IMinerProfile } from "@store/minerProfiles/reducer";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { makeNotifs } from "@utils/makeNotifs";
import { FormEvent, useState } from "react";
import { useDispatch } from "react-redux";
import { mapMinerProfileEditorErrors } from "../../../Pages/Managment/MinerPrifilesInfo/mapMinerProfileEditorErrors";
import { ICreateMinerProfileMobxProps } from "./CreateMinerProfileMobx.props";

export const useCreateMinerProfileMobxControl = (
  props: ICreateMinerProfileMobxProps,
  editorStore: IMinerProfileEditorStore
) => {
  const dispatch = useDispatch();
  const { onSuccess } = useGlobalNotifs();
  const { ok } = makeNotifs();
  const { enqueue } = useApiRequests();
  const [errors, setErrors] = useState<{ [key: string]: boolean }>();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrors(undefined);

    if (!editorStore.validate()) {
      setErrors(mapMinerProfileEditorErrors(editorStore.errors));
      return;
    }

    const payload = editorStore.savePayload;
    if (!payload) return;

    const res = await enqueue<AddMinerProfileResponse>(
      new AddMinerProfile(payload as IAddMinerProfileParams),
      {
        onLoadingStatusChanged: setLoading,
      }
    );
    if (!res) return;

    const createdProfile = {
      id: res.Record,
      name: payload.name,
      hash: payload.hash,
      performance: payload.performance,
      consumption: payload.consumption,
      meta: JSON.parse(payload.meta),
    } as IMinerProfile;

    dispatch(addMinerProfile(createdProfile));
    props.onCreate?.(res.Record);
    onSuccess(ok.success);
    props.handleDestroy();
  };

  return {
    errors,
    loading,
    onSubmit,
  };
};
